import { api } from '@api/api2';

export const getTicketPriorities = () => api.v1('get', 'tck/priorities/list');
